import { createApp } from 'vue'
import ElementPlus, { ClickOutside } from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/iconfont/iconfont.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import dateMixin from './mixin/dateMixin'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'vue3-virtual-scroller/dist/vue3-virtual-scroller.css'
import VueVirtualScroller from 'vue3-virtual-scroller'
import { createPinia } from 'pinia'
// createApp(App).use(store).use(router).mount('#app')
const pinia = createPinia()
const solidIcons = Object.values(fas)
library.add(...solidIcons)
const app = createApp(App)
app.use(store)
app.use(router)
app.component('font-awesome-icon', FontAwesomeIcon)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, { locale: zhCn, size: 'small', zIndex: 2000 })
app.use(VueVirtualScroller)
app.use(pinia)
app.directive('clickOutside', ClickOutside)
app.mixin(dateMixin)
app.mount('#app')

const debounce = (fn, delay) => {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor (callback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}
